/* ==============================================================================================
 * FLOATING LABEL SELECT
 * ============================================================================================== */

var Sushi;

(function (Sushi, Plugins) {
	"use strict";

	var BasePlugin = Plugins.BasePlugin;
	var FloatingLabel = Plugins.FloatingLabel;
	var Events = Sushi.Events;
	var Select = Plugins.Select;

	var FloatingLabelSelect = function (triggerElement) {
		BasePlugin.call(this, triggerElement);

		Events(triggerElement).on("*.Select.aftercreate", function (event) {
			if (triggerElement.hasAttribute("required")) {
				event.detail.select.containerElement.classList.add("c-input--required");
			}
		});

		var select = new Select(triggerElement);
		var floatingLabel = new FloatingLabel(triggerElement);

		this.disable = function () {
			select.containerElement.style.pointerEvents = "none";
			select.triggerElement.setAttribute("disabled", "disabled");
			select.buttonElement.setAttribute("disabled", "disabled");
		};

		this.enable = function () {
			select.containerElement.style.pointerEvents = "all";
			select.triggerElement.removeAttribute("disabled");
			select.buttonElement.removeAttribute("disabled");
        };

        if (triggerElement.disabled) {
            this.disable();
		}
		
		Events(triggerElement).on("Select.change", function () {
			floatingLabel.update();
		});
	};

	FloatingLabelSelect.displayName = "FloatingLabelSelect";

	FloatingLabelSelect.prototype = Object.create(Select.prototype);

	var proto = FloatingLabelSelect.prototype;

	proto.constructor = FloatingLabelSelect;

	Plugins.FloatingLabelSelect = FloatingLabelSelect;
})(Sushi || (Sushi = {}), Sushi.Plugins || (Sushi.Plugins = {}));
